var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"slider",staticClass:"slider-container",style:({
      flexDirection: _vm.reversed ? 'column': 'column-reverse',
     })},_vm._l((_vm.count),function(n){return _c('div',{key:n,staticClass:"slider-content"},_vm._l((_vm.images),function(path,idx){return _c('img',{key:idx,attrs:{"src":path}})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }